import { Suspense, type ReactNode } from "react";

export const defaultLazyRouteFallback = (
	<div className="min-h-screen bg-background p-8">
		<div className="space-y-4">
			<div className="h-12 w-full animate-pulse rounded-md bg-primary/10" />
			<div className="h-64 w-full animate-pulse rounded-md bg-primary/10" />
			<div className="h-32 w-full animate-pulse rounded-md bg-primary/10" />
		</div>
	</div>
);

export interface LazyRouteProps {
	children: ReactNode;
	fallback?: ReactNode;
}

/**
 * Suspense boundary for React.lazy() route elements.
 * Never render a bare lazy() component in a route without this (or ClientOnlyRoute).
 */
export const LazyRoute = ({
	children,
	fallback = defaultLazyRouteFallback,
}: LazyRouteProps) => {
	return <Suspense fallback={fallback}>{children}</Suspense>;
};
